import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.SituationsCommunications;

export const statusSelector = createSelector(
  rootSelector,
  (situationsCommunications) => situationsCommunications.status
);

export const errorSelector = createSelector(rootSelector, (situationsCommunications) => situationsCommunications.error);

const situationsCommunicationsSelector = createSelector(rootSelector, (situations) => situations.data);

export default {
  statusSelector,
  errorSelector,
  situationsCommunicationsSelector,
};
